import React from 'react';
import Responsive from 'react-responsive';

const Desktop = (props) => <Responsive {...props} minWidth={1024} />;
const Tablet = (props) => <Responsive {...props} minWidth={768} maxWidth={1023} />;
const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
const Default = (props) => <Responsive {...props} minWidth={768} />;
const MobileOrTablet = (props) => <Responsive {...props} maxWidth={1023} />;

export { Desktop, Tablet, Mobile, Default, MobileOrTablet };
